import { Chip } from "@mui/material";
import styled from "@mui/material/styles/styled";

const PlanChip = styled(Chip)(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "8px",
  border: `1.5px solid ${theme.palette.shades.primary[500]}`,
  color: theme.palette.shades.primary[500],
  textTransform: "uppercase",
  height: "22px",
  fontWeight: 500,
  width: "fit-content",
  "& .MuiChip-label": { padding: "0 6px" },
}));

export default PlanChip;
